// date-fns format
export const dateTimeFormat = 'MM/dd/yyyy HH:mm';
export const dateFormat = 'MM/dd/yyyy';
export const dateMonthDayFormat = 'MMM dd';
export const timeFormat = 'HH:mm';
export const timeWithPeriodFormat = 'hh:mm aa';
export const timeWithSecondsFormat = 'HH:mm:ss';
// moment format
export const datePickerFormat = 'MM/DD/YYYY';
export const datePickerFormats = {
  daily: 'MM/DD/YYYY',
  weekly: '[W]ww/YYYY',
  monthly: 'MM/YYYY',
  yearly: 'YYYY',
};
